(() => {
  if (window.sleepyRemoval) return;
  const configNode = document.querySelector('[data-removal-config]');
  if (!configNode) return;
  window.sleepyRemoval = true;
  const config = JSON.parse(configNode.textContent);
  config.variants ||= [];
  const strings={
    save_error:'We couldn’t save your cart. Please try again.',
    uncovered_address:'We can’t confirm collection for this address. Please contact SleepyCo on 027 533 7920, or untick removal to buy your mattress. Islands are excluded.',
    street_required:'Enter your full street address, including the street number and any unit.',
    postcode_required:'Enter a four-digit New Zealand postcode.',
    pending_address:'Choose your full address, or enter it manually.',
    address_prompt:'Enter your address to see the collection fee.',
    service_unavailable:'This collection option is unavailable. Contact SleepyCo, or untick removal to buy your mattress.',
    zone_label:'Includes GST. {zone} zone.',
    collection_address_admin:'Use the final shipping address on this order.',
    collection_address_changes_admin:'Check the final shipping address against the quoted address. Any zone change needs a revised quote and customer approval before collection.',
    service_name:'Outdoor collection for one old mattress',
    collection_address_customer:'Same as the final shipping address on this order',
    collection_address_changes_customer:'Any change of collection zone needs a revised quote and approval before collection.',
    service_add_error:'We couldn’t add the collection service. Please try again.',
    service_update_error:'We couldn’t update the collection service. Please try again.',
    service_confirm_error:'We couldn’t confirm the collection fee. Please try again.',
    service_contact:'This collection option is unavailable. Please contact SleepyCo.',
    mattress_qty_error:'The selected mattress quantity could not be added. Please check availability and try again.',
    cart_changed:'Your cart changed. Please refresh the page before trying again.',
    mattress_qty_unavailable:'The selected mattress quantity is unavailable. Please adjust the quantity.',
    cart_save_error:'We couldn’t finish saving your cart. Please try again.',
    update_address:'Update collection address',
    remove_collection:'Remove collection',
    legacy_address_error:'Please reopen your mattress page to update the collection address, or remove collection to continue.',
    legacy_service_unavailable:'This collection option is unavailable. Please contact SleepyCo, or remove collection to continue.',
    choose_available:'Please select an available mattress size and quantity.',
    adding:'Adding your mattress and collection…',
    adding_mattress:'Adding your mattress…',
    shared_collection_address:'Use the same delivery and collection address for all mattress removals in this order. Contact SleepyCo for collection at another address.',
    ...config.strings
  };
  const root = window.Shopify?.routes?.root || '/';
  const keys = {requested:'Old-mattress removal',street:'Collection street address',locality:'Collection locality',postcode:'Collection postcode'};
  const normal = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g,'').trim().toLowerCase().replace(/\s+/g,' ');
  const zoneFor = locality => config.zones[normal(locality)] || null;
  const priceFor = locality => ({Base:5000,Near:8000,Middle:8000,'Outer cap':10000})[zoneFor(locality)] || null;
  const service = item => item.handle === config.handle || item.properties?._sleepy_removal === 'v1';
  const eligible = item => !service(item) && ((config.eligibleIds || []).includes(Number(item.product_id)) || /mattress/i.test(item.product_type || ''));
  let storedRemoval=!!config.requested || !!config.hasService;
  const money = cents => new Intl.NumberFormat('en-NZ',{style:'currency',currency:'NZD'}).format(cents/100);
  const contact = strings.uncovered_address;
  const api = async (path,body) => {
    let response,data;
    try {
      response=await fetch(root+path,{method:body?'POST':'GET',headers:{Accept:'application/json',...(body?{'Content-Type':'application/json'}:{})},...(body?{body:JSON.stringify(body)}:{}),cache:'no-store'});
      data=await response.json();
    } catch {throw new Error(strings.save_error);}
    if (!response.ok || data.status >= 400) throw new Error(data.description || data.message || strings.save_error);
    return data;
  };
  let pending = Promise.resolve();
  const enqueue = action => {
    const operation = pending.catch(()=>{}).then(action);
    pending = operation;
    return operation;
  };
  const states = new WeakMap();
  const cards = () => document.querySelectorAll('[data-removal-product]');
  const markSelection = () => document.documentElement.classList.toggle('scr-removal-selected',storedRemoval || Array.from(cards()).some(card=>card.querySelector('[data-removal-select]')?.checked));
  const readAddress = card => Object.fromEntries(['street','locality','postcode'].map(field=>[field,card.querySelector(`[data-removal-${field}]`)?.value.trim() || '']));
  const addressPending = card => card.querySelector('[data-removal-address]')?.dataset.addressPending==='true';
  const validAddress = (card,report=false) => {
    if (addressPending(card)) return false;
    const address = readAddress(card);
    const values = [address.street.length>=5,!!priceFor(address.locality),/^\d{4}$/.test(address.postcode)];
    const messages = [strings.street_required,contact,strings.postcode_required];
    ['street','locality','postcode'].forEach((field,index)=>card.querySelector(`[data-removal-${field}]`)?.setCustomValidity(values[index]?'':messages[index]));
    if (report && !values.every(Boolean)) {
      const manual = card.querySelector('[data-removal-manual-fields]');
      if (manual) manual.hidden=false;
      const index=values.findIndex(value=>!value);
      card.querySelector(`[data-removal-${['street','locality','postcode'][index]}]`)?.reportValidity();
    }
    return values.every(Boolean);
  };
  const selection = card => {
    const state = states.get(card);
    const form = document.getElementById(card.dataset.form);
    const data = form ? new FormData(form) : null;
    const id = Number(data?.get('id') || form?.querySelector('[name="id"]')?.value);
    const quantity = Number(data?.get('quantity') || form?.querySelector('[name="quantity"]')?.value || 1);
    const variant = state?.variants.find(item=>Number(item.id)===id);
    return {form,data,id,quantity,variant};
  };
  const clearQuote = card => {
    delete card.dataset.quote;
    delete card.dataset.quotePrice;
    const panel = card.querySelector('[data-removal-quote]');
    if (panel) panel.hidden=true;
    const subtotal=card.querySelector('[data-removal-subtotal]');
    if (subtotal) subtotal.hidden=true;
    const subtotalValue=card.querySelector('[data-removal-subtotal-value]');
    if (subtotalValue) subtotalValue.textContent='';
    const addressSummary=card.querySelector('[data-removal-address-summary]');
    if (addressSummary) addressSummary.textContent='';
  };
  const setStatus = (card,message,error=false) => {
    let output = card.querySelector('[data-removal-status]');
    let purchaseOutput=card.querySelector('[data-removal-purchase-status]');
    if (!card.querySelector('[data-removal-select]')?.checked && message) {
      if (!purchaseOutput) {
        purchaseOutput=document.createElement('p');
        purchaseOutput.dataset.removalPurchaseStatus='';
        card.append(purchaseOutput);
      }
      if (output) output.textContent='';
      output=purchaseOutput;
      output.hidden=false;
    } else if (purchaseOutput) {purchaseOutput.textContent='';purchaseOutput.hidden=true;}
    if (!output) return;
    output.textContent=message;
    output.setAttribute('role',error?'alert':'status');
    output.setAttribute('aria-live',error?'assertive':'polite');
  };
  const quote = (card,{report=false}={}) => {
    const checked=card.querySelector('[data-removal-select]')?.checked;
    if (!checked) {clearQuote(card);setStatus(card,'');return false;}
    if (!validAddress(card,report)) {
      clearQuote(card);
      const address=readAddress(card);
      setStatus(card,addressPending(card)?strings.pending_address:address.locality && !zoneFor(address.locality)?contact:strings.address_prompt,!!(!addressPending(card) && address.locality && !zoneFor(address.locality)));
      return false;
    }
    const address=readAddress(card),zone=zoneFor(address.locality),price=priceFor(address.locality);
    const selected=selection(card);
    const serviceVariant=config.variants.find(item=>item.title===zone);
    if (!serviceVariant || !serviceVariant.available || Number(serviceVariant.price)!==price) {
      clearQuote(card);setStatus(card,strings.service_unavailable,true);return false;
    }
    card.dataset.quote=JSON.stringify(address);
    card.dataset.quotePrice=String(price);
    const addressSummary=card.querySelector('[data-removal-address-summary]');
    if (addressSummary) addressSummary.textContent=`${address.locality} ${address.postcode}`;
    const fee=card.querySelector('[data-removal-fee-value]');
    const zoneLabel=card.querySelector('[data-removal-zone]');
    const subtotal=card.querySelector('[data-removal-subtotal-value]');
    const subtotalRow=card.querySelector('[data-removal-subtotal]');
    const panel=card.querySelector('[data-removal-quote]');
    if (fee) fee.textContent=money(price);
    if (zoneLabel) zoneLabel.textContent=strings.zone_label.replace('{zone}',zone);
    const validSelection=!!selected.variant?.available && Number.isFinite(Number(selected.variant.price)) && Number(selected.variant.price)>=0 && Number.isSafeInteger(selected.quantity) && selected.quantity>0;
    if (subtotal) subtotal.textContent=validSelection?money(Number(selected.variant.price)*selected.quantity+price):'';
    if (subtotalRow) subtotalRow.hidden=!validSelection;
    if (panel) panel.hidden=false;
    setStatus(card,validSelection?'':strings.choose_available,!validSelection);
    return true;
  };
  const removalAttributes = (address,zone) => ({
    [keys.requested]:'Confirmed',
    [keys.street]:address.street,
    [keys.locality]:address.locality,
    [keys.postcode]:address.postcode,
    'Collection zone':zone,
    'Collection address':strings.collection_address_admin,
    'Collection address changes':strings.collection_address_changes_admin
  });
  const clearedAttributes = () => ({[keys.requested]:'',[keys.street]:'',[keys.locality]:'',[keys.postcode]:'','Collection zone':'','Collection address':'','Collection address changes':''});
  const removalProperties = (address,zone,token) => ({
    Service:strings.service_name,
    _quoted_collection_address:`${address.street}, ${address.locality} ${address.postcode}`,
    _collection_zone:zone,
    _collection_address:strings.collection_address_customer,
    _collection_address_changes:strings.collection_address_changes_customer,
    _sleepy_removal:'v1',
    _sleepy_removal_booking:token
  });
  const checkoutUrl = address => root+'checkout?'+new URLSearchParams({
    'checkout[shipping_address][address1]':address.street,
    'checkout[shipping_address][address2]':'',
    'checkout[shipping_address][city]':address.locality,
    'checkout[shipping_address][province]':'Auckland',
    'checkout[shipping_address][country]':'New Zealand',
    'checkout[shipping_address][zip]':address.postcode
  });
  const freeze = (card,form) => {
    const scope=card.closest('.sp-product') || card;
    const controls=Array.from(new Set([...form.elements,...scope.querySelectorAll('input,select,textarea,button')]));
    const captured=controls.map(input=>({input,disabled:input.disabled}));
    controls.forEach(input=>{input.disabled=true;});
    card.setAttribute('aria-busy','true');
    return ()=>{captured.forEach(({input,disabled})=>{input.disabled=disabled;});card.removeAttribute('aria-busy');};
  };
  const token = () => window.crypto?.randomUUID?.() || `scr-${Date.now()}-${Math.random().toString(36).slice(2)}`;
  const mattressLine = selected => {
    const properties={};
    for (const [name,value] of selected.data.entries()) {
      const match=name.match(/^properties\[([^\]]+)\]$/);
      if (match && typeof value==='string') properties[match[1]]=value;
    }
    const sellingPlan=selected.data.get('selling_plan');
    return {id:selected.id,quantity:selected.quantity,properties,...(sellingPlan?{selling_plan:sellingPlan}:{})};
  };
  const mattressMatches = (cart,operation) => cart.items.filter(item=>item.properties?._sleepy_removal_add===operation.token && Number(item.variant_id)===operation.item.id);
  const mattressQuantity = (cart,operation) => mattressMatches(cart,operation).reduce((sum,item)=>sum+Number(item.quantity),0);
  const matchesProperties = (item,properties) => Object.entries(properties).every(([key,value])=>String(item?.properties?.[key]??'')===String(value));
  const parentOf = (cart,line) => cart.items.find(item=>item.key===line?.parent_relationship?.parent_key && eligible(item));
  const operationParent = (cart,operation) => mattressMatches(cart,operation).find(eligible);
  const servicesFor = (cart,parent) => parent
    ? cart.items.filter(item=>service(item) && parentOf(cart,item)?.key===parent.key)
    : [];
  const correctService = (cart,variant,price,properties,findParent) => {
    const parent=findParent(cart),lines=servicesFor(cart,parent),line=lines[0];
    return !!parent && lines.length===1 && parentOf(cart,line)?.key===parent.key &&
      Number(line.quantity)===1 && Number(line.variant_id)===Number(variant.id) &&
      Number(line.final_price??line.price)===price && matchesProperties(line,properties);
  };
  const syncService = async (cart,variant,price,properties,findParent) => {
    const matchingLine = current => {
      const parent=findParent(current);
      return parent && current.items.find(item=>service(item) &&
        Number(item.variant_id)===Number(variant.id) && parentOf(current,item)?.key===parent.key);
    };
    let desired=matchingLine(cart),failure;
    if (!desired) {
      const parent=findParent(cart);
      if (!parent) throw new Error(strings.cart_changed);
      try {
        await api('cart/add.js',{items:[{id:variant.id,quantity:1,properties,parent_line_key:parent.key}]});
      } catch(error) {failure=error;}
      cart=await api('cart.js');
      desired=matchingLine(cart);
      if (!desired) {
        // A standalone line must never survive a failed attempt to attach it.
        const updates=Object.fromEntries(cart.items.filter(item=>service(item) && !parentOf(cart,item) &&
          item.properties?._sleepy_removal_booking===properties._sleepy_removal_booking).map(item=>[item.key,0]));
        if (Object.keys(updates).length) await api('cart/update.js',{updates});
        throw failure || new Error(strings.service_add_error);
      }
    }
    if (Number(desired.quantity)!==1 || !matchesProperties(desired,properties)) {
      try {await api('cart/change.js',{id:desired.key,quantity:1,properties});} catch(error) {failure=error;}
      cart=await api('cart.js');
      desired=matchingLine(cart);
      if (!desired || Number(desired.quantity)!==1 || !matchesProperties(desired,properties)) {
        throw failure || new Error(strings.service_update_error);
      }
    }
    const updates=Object.fromEntries(servicesFor(cart,findParent(cart)).filter(item=>item.key!==desired.key).map(item=>[item.key,0]));
    if (Object.keys(updates).length) {
      try {await api('cart/update.js',{updates});} catch(error) {failure=error;}
      cart=await api('cart.js');
    }
    if (!correctService(cart,variant,price,properties,findParent)) throw failure || new Error(strings.service_confirm_error);
    return cart;
  };
  const saveMattress = async (operation,collection=null) => {
    let cart=await api('cart.js');
    let quantity=mattressQuantity(cart,operation);
    if (!quantity) {
      const items=[{...operation.item,properties:{...operation.item.properties,_sleepy_removal_add:operation.token}}];
      if (collection) items.push({id:collection.variant.id,quantity:1,properties:collection.properties,parent_id:operation.item.id});
      let failed;
      try {await api('cart/add.js',{items});} catch(error) {failed=error;}
      cart=await api('cart.js');
      quantity=mattressQuantity(cart,operation);
      if (quantity!==operation.item.quantity) {
        if (!quantity) {
          const orphan=Object.fromEntries(cart.items.filter(item=>service(item) && item.properties?._sleepy_removal_booking===operation.token).map(item=>[item.key,0]));
          if (Object.keys(orphan).length) await api('cart/update.js',{updates:orphan});
        }
        throw failed || new Error(strings.mattress_qty_error);
      }
    }
    if (quantity!==operation.item.quantity) {
      const lines=mattressMatches(cart,operation);
      if (lines.length!==1) throw new Error(strings.cart_changed);
      let failed;
      try {await api('cart/change.js',{id:lines[0].key,quantity:operation.item.quantity,properties:lines[0].properties});} catch(error) {failed=error;}
      cart=await api('cart.js');
      if (mattressQuantity(cart,operation)!==operation.item.quantity) throw failed || new Error(strings.mattress_qty_unavailable);
    }
    return cart;
  };
  const quotedAddress = address => normal(`${address.street}, ${address.locality} ${address.postcode}`);
  const savedAddress = (cart,properties={}) => Object.fromEntries(['street','locality','postcode'].map(field=>[
    field,String(Object.hasOwn(cart.attributes || {},keys[field])?cart.attributes[keys[field]]:properties[keys[field]] || '').trim()
  ]));
  const verifySharedAddress = (cart,address,exceptParent) => {
    for (const item of cart.items.filter(service)) {
      const parent=parentOf(cart,item);
      if (!parent || parent.key===exceptParent?.key) continue;
      const saved=item.properties?._quoted_collection_address || quotedAddress(savedAddress(cart,item.properties));
      if (normal(saved)!==quotedAddress(address)) throw new Error(strings.shared_collection_address);
    }
  };
  const clearUnlinked = async cart => {
    const updates=Object.fromEntries(cart.items.filter(item=>service(item) && !parentOf(cart,item)).map(item=>[item.key,0]));
    return Object.keys(updates).length ? api('cart/update.js',{updates}) : cart;
  };
  const savePurchase = async (operation,address) => {
    const zone=zoneFor(address.locality),price=priceFor(address.locality);
    const variant=config.variants.find(item=>item.title===zone);
    if (!variant?.available || Number(variant.price)!==price) throw new Error(strings.service_contact);
    const properties=removalProperties(address,zone,operation.token);
    const findParent=current=>operationParent(current,operation);
    const before=await api('cart.js');
    verifySharedAddress(before,address,findParent(before));
    let cart=await saveMattress(operation,{variant,properties});
    cart=await syncService(cart,variant,price,properties,findParent);
    cart=await clearUnlinked(cart);
    const attributes=removalAttributes(address,zone);
    let failed;
    try {await api('cart/update.js',{attributes});} catch(error) {failed=error;}
    cart=await api('cart.js');
    const saved=Object.entries(attributes).every(([key,value])=>String(cart.attributes?.[key]??'')===String(value));
    if (!saved || !correctService(cart,variant,price,properties,findParent) || mattressQuantity(cart,operation)!==operation.item.quantity) throw failed || new Error(strings.cart_save_error);
    storedRemoval=true;
    return checkoutUrl(address);
  };
  const clearService = async cart => {
    const updates=Object.fromEntries(cart.items.filter(service).map(item=>[item.key,0]));
    await api('cart/update.js',{updates,attributes:clearedAttributes()});
    storedRemoval=false;
    markSelection();
  };
  const checkoutForCart = async cart => {
    if (!cart.attributes?.[keys.requested] && !cart.items.some(service)) {storedRemoval=false;return root+'checkout';}
    if (!cart.items.some(service) && cart.attributes?.[keys.requested]!=='Requested') {await clearService(cart);return root+'checkout';}
    const serviceLines=cart.items.filter(service);
    const linkedLines=serviceLines.filter(item=>parentOf(cart,item));
    const linked=linkedLines[0];
    const existing=(linked || serviceLines[0])?.properties || {};
    const booking=cart.attributes?.[keys.requested];
    const legacyAddress=existing[keys.street] && existing[keys.locality] && existing[keys.postcode];
    if (!cart.items.some(eligible) || (!linked && booking!=='Confirmed' && booking!=='Requested' && !legacyAddress) ||
      (!linked && serviceLines.some(item=>item.parent_relationship))) {
      await clearService(cart);
      return root+'checkout';
    }
    const address=savedAddress(cart,existing);
    const zone=zoneFor(address.locality),price=priceFor(address.locality);
    if (address.street.length<5 || !price || !/^\d{4}$/.test(address.postcode)) throw new Error(strings.legacy_address_error);
    const variant=config.variants.find(item=>item.title===zone);
    if (!variant?.available || Number(variant.price)!==price) throw new Error(strings.legacy_service_unavailable);
    verifySharedAddress(cart,address);
    const parents = linkedLines.length
      ? [...new Map(linkedLines.map(line=>[line.parent_relationship.parent_key,line])).values()]
      : [null];
    const bookings = parents.map(line=>{
      const parent=parentOf(cart,line) || cart.items.find(eligible);
      const parentToken=parent.properties?._sleepy_removal_add;
      return {
        properties:removalProperties(address,zone,line?.properties?._sleepy_removal_booking || existing._sleepy_removal_booking || token()),
        findParent:current=>current.items.find(item=>eligible(item) &&
          (parentToken?item.properties?._sleepy_removal_add===parentToken:item.key===parent.key))
      };
    });
    for (const {properties,findParent} of bookings) {
      if (!correctService(cart,variant,price,properties,findParent)) {
        cart=await syncService(cart,variant,price,properties,findParent);
      }
    }
    cart=await clearUnlinked(cart);
    const attributes=removalAttributes(address,zone);
    let failure;
    try {await api('cart/update.js',{attributes});} catch(error) {failure=error;}
    cart=await api('cart.js');
    if (cart.items.filter(service).length!==bookings.length ||
      !bookings.every(({properties,findParent})=>correctService(cart,variant,price,properties,findParent)) ||
      !Object.entries(attributes).every(([key,value])=>String(cart.attributes?.[key]??'')===String(value))) {
      throw failure || new Error(strings.cart_save_error);
    }
    return checkoutUrl(address);
  };
  let cartBusy=false,cartRestore=null;
  const cartError = (error,target,cart) => {
    let output=document.querySelector('[data-removal-cart-status]');
    if (!output) {
      output=document.createElement('div');
      output.dataset.removalCartStatus='';
      output.className='scr-cart-status';
      output.setAttribute('role','alert');
      const button=target?.matches?.('button,a')?target:document.querySelector('[name="checkout"],a[href$="/checkout"]');
      if (button) button.before(output);
      else (document.querySelector('main') || document.body).append(output);
    }
    output.replaceChildren();
    const message=document.createElement('p');
    message.textContent=error.message;
    output.append(message);
    const mattress=cart?.items.find(eligible);
    if (mattress?.url) {
      const update=document.createElement('a');
      update.href=mattress.url;
      update.textContent=strings.update_address;
      output.append(update);
    }
    const remove=document.createElement('button');
    remove.type='button';
    remove.textContent=strings.remove_collection;
    remove.addEventListener('click',()=>{
      if (cartBusy) return;
      cartBusy=true;remove.disabled=true;
      enqueue(async()=>clearService(await api('cart.js'))).then(()=>window.location.assign(root+'cart')).catch(failure=>{message.textContent=failure.message;cartBusy=false;remove.disabled=false;});
    });
    output.append(remove);
    output.scrollIntoView({block:'nearest',behavior:'auto'});
  };
  const cartCheckout = async target => {
    if (cartBusy) return;
    cartBusy=true;
    const disabled=target?.disabled;
    if (target && 'disabled' in target) target.disabled=true;
    cartRestore=()=>{cartBusy=false;if(target && 'disabled' in target)target.disabled=disabled;};
    let cart,leaving=false;
    try {
      const url=await enqueue(async()=>{
        cart=await api('cart.js');
        return checkoutForCart(cart);
      });
      window.location.assign(url);leaving=true;
    } catch(error) {cartError(error,target,cart);}
    finally {if (!leaving) {cartRestore?.();cartRestore=null;}}
  };
  const productCard = form => form && document.getElementById(form.dataset.removalForm);
  const replaying = new WeakSet();
  const initProduct = card => {
    if (states.has(card)) {states.get(card).sync?.();return;}
    const node=card.querySelector('[data-removal-product-variants], [data-removal-variants]');
    const state={variants:node?JSON.parse(node.textContent):[],busy:false,cleanup:null,cleanupError:null,operation:null,restore:null};
    states.set(card,state);
    card.dataset.ready='true';
    const checkbox=card.querySelector('[data-removal-select]');
    const details=card.querySelector('[data-removal-address-wrap]');
    const toggleFields=()=>details.querySelectorAll('input,select,textarea').forEach(input=>{input.disabled=!checkbox.checked;});
    const form=document.getElementById(card.dataset.form);
    if (form) form.dataset.removalForm=card.id;
    const refresh=()=>{if(!state.busy) quote(card);};
    card.querySelector('[data-removal-address]')?.addEventListener('input',refresh);
    card.querySelector('[data-removal-address]')?.addEventListener('change',refresh);
    card.querySelector('[data-removal-address]')?.addEventListener('address:pending',refresh);
    const section=card.closest('.sp-product') || form?.parentElement;
    state.sync=()=>{
      const currentForm=document.getElementById(card.dataset.form);
      if (!currentForm) return;
      currentForm.dataset.removalForm=card.id;
      const add=Array.from(currentForm.elements).find(input=>input.name==='add') || currentForm.querySelector('[name="add"]');
      const blocked=state.busy || !add || add.disabled || add.getAttribute('aria-disabled')==='true';
      (section || card).querySelectorAll('[data-removal-buy-now]').forEach(button=>{
        if (button.form && button.form!==currentForm) return;
        if (button.disabled!==!!blocked) button.disabled=!!blocked;
      });
    };
    state.observer=new MutationObserver(state.sync);
    state.observer.observe(section || form || card,{childList:true,subtree:true,attributes:true,attributeFilter:['disabled','aria-disabled']});
    state.sync();
    section?.addEventListener('variant:change',()=>requestAnimationFrame(refresh));
    section?.addEventListener('change',()=>requestAnimationFrame(refresh));
    state.clean=()=>{
      const selected=selection(card);
      const operation=selected.data && state.operation?.signature===JSON.stringify(mattressLine(selected))
        ? state.operation
        : null;
      const cleanup=enqueue(async()=>{
        if (checkbox.checked) return;
        const cart=await api('cart.js');
        if (checkbox.checked) return;
        const parent=operation && operationParent(cart,operation);
        const current=servicesFor(cart,parent);
        if (!current.length) {
          if (cart.attributes?.[keys.requested]==='Requested' && !cart.items.some(item=>service(item) && parentOf(cart,item))) {
            await clearService(cart);
          }
          return;
        }
        if (!cart.items.some(item=>service(item) && !current.includes(item))) {
          await clearService(cart);
          return;
        }
        const updates=Object.fromEntries(current.map(item=>[item.key,0]));
        await api('cart/update.js',{updates});
      });
      state.cleanup=cleanup;
      cleanup.then(()=>{state.cleanupError=null;if(!checkbox.checked && !state.busy)setStatus(card,'');}).catch(error=>{state.cleanupError=error;if(!checkbox.checked)setStatus(card,error.message,true);}).finally(()=>{if(state.cleanup===cleanup)state.cleanup=null;});
      return cleanup;
    };
    checkbox.addEventListener('change',()=>{
      details.hidden=!checkbox.checked;
      toggleFields();
      markSelection();
      if (checkbox.checked) {refresh();return;}
      clearQuote(card);setStatus(card,'');
      state.clean();
    });
    const manual=card.querySelector('[data-removal-manual]');
    manual?.addEventListener('click',()=>{
      const address=card.querySelector('[data-removal-address]');
      address.dataset.manualAddress='true';
      address.dataset.addressPending='false';
      const fields=card.querySelector('[data-removal-manual-fields]');
      if (fields) {fields.hidden=false;manual.setAttribute('aria-expanded','true');fields.querySelector('input')?.focus();}
      refresh();
    });
    details.hidden=!checkbox.checked;
    toggleFields();
    quote(card);
  };
  document.addEventListener('submit',event=>{
    const card=productCard(event.target);
    if (!card) {
      if (storedRemoval && event.target.id==='cart' && (!event.submitter || event.submitter.name==='checkout')) {event.preventDefault();event.stopImmediatePropagation();cartCheckout(event.submitter || event.target.querySelector('[name="checkout"]'));}
      return;
    }
    if (replaying.has(event.target)) return;
    const state=states.get(card),checkbox=card.querySelector('[data-removal-select]');
    const buyNow=event.submitter?.name==='buy_now' || event.submitter?.hasAttribute?.('data-removal-buy-now');
    if (!checkbox.checked && !state.cleanup && !state.cleanupError && !buyNow) return;
    event.preventDefault();event.stopImmediatePropagation();
    if (state.busy) return;
    if (!checkbox.checked && !buyNow) {
      state.busy=true;
      const form=event.target,submitter=event.submitter;
      const cleanup=state.cleanupError?state.clean():state.cleanup;
      Promise.resolve(cleanup).then(()=>new Promise(resolve=>setTimeout(resolve,0))).then(()=>{
        if (checkbox.checked) {state.busy=false;form.requestSubmit(submitter?.isConnected===false?undefined:submitter);return;}
        setStatus(card,'');
        replaying.add(form);
        try {form.requestSubmit(submitter?.isConnected===false?undefined:submitter);} finally {replaying.delete(form);}
      }).catch(error=>setStatus(card,error.message,true)).finally(()=>{state.busy=false;});
      return;
    }
    const withRemoval=checkbox.checked;
    if (withRemoval && !quote(card,{report:true})) return;
    const selected=selection(card);
    if (!selected.form?.reportValidity()) return;
    if (!selected.variant?.available || !Number.isSafeInteger(selected.quantity) || selected.quantity<1) {setStatus(card,strings.choose_available,true);return;}
    const item=mattressLine(selected);
    const signature=JSON.stringify(item);
    if (!state.operation || state.operation.signature!==signature) state.operation={token:token(),signature,item};
    const operation=state.operation,address=withRemoval?readAddress(card):null;
    const cleanup=state.cleanupError?state.clean():state.cleanup;
    state.busy=true;
    state.restore=freeze(card,selected.form);
    setStatus(card,withRemoval?strings.adding:strings.adding_mattress);
    let leaving=false;
    enqueue(async()=>{
      if (cleanup) await cleanup;
      if (withRemoval) return savePurchase(operation,address);
      const cart=await saveMattress(operation);
      return checkoutForCart(cart);
    }).then(url=>{
      window.location.assign(buyNow?url:root+'cart');leaving=true;
    }).catch(error=>setStatus(card,error.message,true)).finally(()=>{
      if (!leaving) {state.restore?.();state.restore=null;state.busy=false;state.sync?.();}
    });
  },true);
  document.addEventListener('click',event=>{
    if (!storedRemoval) return;
    const candidate=event.target.closest('button');
    const checkout=event.target.closest('[name="checkout"],a[href$="/checkout"],[data-removal-drawer-checkout]') || (/^check\s*out$/i.test(candidate?.textContent.trim() || '')?candidate:null);
    if (!checkout) return;
    event.preventDefault();event.stopImmediatePropagation();cartCheckout(checkout);
  },true);
  const init = () => {cards().forEach(initProduct);markSelection();};
  init();document.addEventListener('shopify:section:load',init);
  window.addEventListener?.('pageshow',event=>{
    if (!event.persisted) return;
    cartRestore?.();cartRestore=null;cartBusy=false;
    cards().forEach(card=>{
      const state=states.get(card);
      state?.restore?.();
      if (state) {state.restore=null;state.busy=false;}
      state?.sync?.();
      quote(card);
    });
    markSelection();
  });
  let scheduled=false;
  new MutationObserver(()=>{if(scheduled)return;scheduled=true;requestAnimationFrame(()=>{scheduled=false;init();});}).observe(document.body,{childList:true,subtree:true});
})();
